module.exports = __webpack_public_path__ + "img/background.456e9bd3.svg";